'use strict';

var _standardError = require('standard-error');

var _standardError2 = _interopRequireDefault(_standardError);

var _httpStatus = require('http-status');

var _httpStatus2 = _interopRequireDefault(_httpStatus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = function (schema, options) {
  var _options = options || { name: 'Object' };

  schema.statics.findByIdOrThrow = function (id, options) {
    var query = this.findOne({ _id: id });
    if (options) {
      query.setOptions(options);
    }
    return query.then(function (doc) {
      if (!doc) {
        throw new _standardError2.default(_options.name + ' ' + id + ' not found', {
          status: _httpStatus2.default.NOT_FOUND
        });
      }

      return doc;
    });
  };
};